import { FlexBox } from '@airship-platform/jam-web/components';
import { useScreen } from '@airship-platform/jam-web/hooks';
import { CircularProgress, Typography } from '@mui/material';
import { useMemo, useState } from 'react';
import { ServiceHistory as ServiceHistoryEntity } from '../../../../data-access/serviceHistory';
import DesktopServiceHistoryView from './DesktopServiceHistoryView';
import MobileServiceHistoryView from './MobileServiceHistoryView';

interface ServiceHistoryProps {
  serviceHistory: ServiceHistoryEntity[];
  isLoading: boolean;
}

const ServiceHistory: React.FC<ServiceHistoryProps> = ({
  serviceHistory,
  isLoading,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { isMobile } = useScreen();

  const paginatedServiceHistory = useMemo(() => {
    return serviceHistory.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  }, [serviceHistory, page, rowsPerPage]);

  const handleChangePage = (newPage: number) => setPage(newPage);

  if (isLoading) {
    return (
      <FlexBox alignItems="center" justifyContent="center">
        <CircularProgress color="primary" size="1.25rem" />
      </FlexBox>
    );
  }

  return (
    <FlexBox flexDirection="column" gap={3}>
      <Typography variant="h4" component="h2">
        Service History
      </Typography>
      {isMobile ? (
        <MobileServiceHistoryView
          paginatedServiceHistory={paginatedServiceHistory}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          totalServiceHistory={serviceHistory.length}
        />
      ) : (
        <DesktopServiceHistoryView
          paginatedServiceHistory={paginatedServiceHistory}
          page={page}
          rowsPerPage={rowsPerPage}
          handleChangePage={handleChangePage}
          setRowsPerPage={setRowsPerPage}
          totalServiceHistory={serviceHistory.length}
        />
      )}
    </FlexBox>
  );
};

export default ServiceHistory;
